import React, { FormEvent, useEffect, useState } from 'react'
import { Col, Form, FormGroup, Input, Label } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Btn, H2, Image, P } from '../AbstractElements';
import { dynamicImage } from '../Utils';
import { EmailAddress, ForgotPassword, Password, RememberPassword, SignIn, SignInAccount } from '../Utils/Constants';
import { Eye, EyeOff } from 'lucide-react';
import { login as loginUser} from '../Services/AuthService';
import { useAuth } from '../Contexts/AuthContext';
import { useUser } from '../Contexts/UserContext';

export default function SignInForm() {
    const navigate = useNavigate();
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [hasInput, setHasInput] = useState(false);
    const [loading, setLoading] = useState(false);
    const toggle = () => setPasswordVisible(!isPasswordVisible);
    const authContext = useAuth();
    const UserContext = useUser();

    // const handleUserUpdate = async (newUserData:any) => {
    //     updateUser(newUserData);
    // };

    const handleSubmit = async(e: FormEvent) => {
        e.preventDefault()
        setLoading(true)

        try {
            const data: any = await loginUser(email, password);
            localStorage.setItem("token", data.login_token); // Store token
            authContext?.login(data.login_token);
            UserContext.updateUser(data.user)
            toast.success(data.message || "Login Successful");
            // console.log(localStorage.getItem('token'))
            navigate(`${process.env.PUBLIC_URL}/dashboard`)
        } catch (err: any) {
            setLoading(false);
            toast.error(err.message || "Invalid credentials");
        }
    };

    useEffect(() => {
        setHasInput(password.length > 0);
    },[password]);

    return (
        <div>
            <div>
                <div className='logo'>
                    {/* <Image className="img-fluid for-light m-auto" src="../assets/images/logo/logo1.png" alt="looginpage" /> */}
                    {/* <Image className="img-fluid for-dark" src="../assets/images/logo/logo-dark.png" alt="logo" /> */}
                    <Image className="img-fluid for-light m-auto" src={dynamicImage(`logo/logo.png`)} alt="looginpage" />
                    <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo.png`)} alt="looginpage" />
                </div>
            </div>
            <div className="login-main">
                <Form className="theme-form" onSubmit={handleSubmit}>
                    <H2 className="text-center">{SignInAccount}</H2>
                    <P className="text-center">{"Enter your email & password to login"}</P>
                    <FormGroup>
                        <Col><Label>{EmailAddress}</Label></Col>
                        <Input type="email" defaultValue={email} placeholder='Enter your email-address' onChange={(event) => setEmail(event.target.value)} />
                    </FormGroup>
                    <FormGroup>
                        <Col><Label>{Password}</Label></Col>
                        <div className="form-input position-relative">
                            <Input type={isPasswordVisible ? 'text' : 'password'} placeholder='Eneter your password' defaultValue={password} onChange={(event) => setPassword(event.target.value)} name="login[password]" />
                            <div className='show-hide' onClick={toggle}>
                                {/* <span className={!isPasswordVisible ? 'show' : ''}></span> */}
                                {isPasswordVisible ? (
                                    <EyeOff size={20} color={hasInput ? 'white' : 'black'}  />
                                ) : (
                                    <Eye size={20} color={hasInput ? 'white' : 'black'}/>
                                )}
                            </div>
                        </div>
                    </FormGroup>
                    <FormGroup className="mb-0 checkbox-checked">
                        <FormGroup className="checkbox-solid-info" check>
                            <Input id="checkbox1" type="checkbox" />
                            <Label htmlFor="checkbox1" check>{RememberPassword}</Label>
                        </FormGroup>
                        <Link className="link" to={`${process.env.PUBLIC_URL}/forgot-password`}>{ForgotPassword}</Link>
                        <div className="text-end mt-3">
                            <Btn color='primary' className="w-100" block disabled={loading}> 
                                {loading ? (
                                    <>
                                        <i className="fa-solid fa-spinner fa-spin me-2"></i> Authenticating...
                                    </>
                                ) : SignIn}
                            </Btn>
                        </div>
                    </FormGroup>
                </Form>
            </div>
        </div>
    )
}